import styles from './ChatLoadingIndicator.module.css';

export function ChatLoadingIndicator() {
  return (
    <div aria-live="polite" className={styles.loading} role="status">
      <span className={styles.label}>AI is generating a response</span>
      <span aria-hidden="true" className={styles.dots}>
        <span />
        <span />
        <span />
      </span>
    </div>
  );
}
